import React from 'react';
import { FormInstance, Select } from 'antd';
import {
  fetchWarehouseLocationList,
  fetchWarehouseProductLocationList,
} from 'services/warehouse';
import { LoadingIcon, message } from 'components/common';

type SelectProps = {
  allowClear?: boolean;
  defaultSelectOneOption?: boolean;
  defaultValue?: number;
  disabled?: boolean;
  form?: FormInstance<any>;
  isLoadingOptions?: Function;
  locationQuery?: StringKAnyVPair;
  locationType: number;
  onChange: (locationNum?: number, row?: any) => void;
  optionVersion?: number;
  product?: StringKAnyVPair;
  showPick?: boolean;
  style?: any;
  title?: string;
  useLastValue?: boolean;
  value?: number;
  warehouseId?: string;
};

const SearchSelect = (props: SelectProps) => {
  const { useRef, useState } = React;
  //const { warehouseId, locationType, value, onChange, showPick, style, form, title } = props;
  const [currentLocationType, setCurrentLocationType] = useState(0);
  const [currentWhId, setCurrentWhId] = useState<any>();
  const [currentProductId, setCurrentProductId] = useState<number>();
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  //const [optionList, setOptionList] = useState<StringKAnyVPair[]>([]);
  const [prdLocationList, setPrdLocationList] = useState<StringKAnyVPair[]>([]);
  const [whLocationList, setWhLocationList] = useState<StringKAnyVPair[]>([]);
  //const timerRef = useRef<any>(null);
  const currentSelectionRef = useRef<any>(null);

  const currentSelectionValue = () => {
    let ret = props.value;

    if (typeof ret !== 'number' && !ret) {
      if (props.useLastValue) {
        if (currentSelectionRef.current > 0) {
          const option = getOptionList().find(e => e.locationNum > 0 && e.locationNum === currentSelectionRef.current);
          //console.log('option', option);
          if (option) ret = option.locationNum;
        }
      }
    }

    return ret; 
  };

  const filterOption = (key: string, opt: any) => {
    //console.log('fi', key, opt);
    if (opt && typeof opt === 'object') {
      const item = data.find(e => e.locationNum === opt.value);

      if (item) {
        return item.locationCode.toUpperCase().includes(key.toUpperCase());
      }
    }

    return false;
  };

  const getOptionList = () => {
    let optList: StringKAnyVPair[] = [];

    switch (props.optionVersion) {
      case undefined:
        optList = getV0OptionList(prdLocationList);
        break;
        
      case 1:
        optList = getV1OptionList(whLocationList, prdLocationList);
        break;
    }

    return optList;
  };

  const getV0OptionList = (list: StringKAnyVPair[]) => {
    //console.log('g0', props.locationQuery);
    return list.filter(e => {
      let [ lotNumber, uom ] = ['', 'EA'];

      if (props.locationQuery) {
        lotNumber = typeof props.locationQuery.lotNumber === 'string' ? props.locationQuery.lotNumber.trim() : lotNumber;
        uom = typeof props.locationQuery.uom === 'string' ? props.locationQuery.uom.trim() : uom;
      }

      //console.log('g0', props.locationQuery, lotNumber, uom);
      const lotEq = typeof e.lotNumber === 'string' ? lotNumber === e.lotNumber.trim() : false;
      const uomEq = typeof e.uom === 'string' ? uom === e.uom.trim() : false;

      return lotEq && uomEq;
    })
    .map(e => ({
      ...e,
      value: e.locationNum,
      key: `${e.locationNum}-${e.lotNumber}-${e.uom}`,
      label: `${e.locationCode}(${e.quantity})`,
    }));
  };

  const getV1OptionList = (
    list1: StringKAnyVPair[],
    list2: StringKAnyVPair[],
  ) => {
    const list3: StringKAnyVPair[] = [];
    const list4: StringKAnyVPair[] = [];
    const qtyDict: StringKAnyVPair = {};

    getV0OptionList(list2).forEach(e => {
      // @ts-ignore
      if (!(e.locationNum in qtyDict)) qtyDict[e.locationNum] = 0;

      // @ts-ignore
      qtyDict[e.locationNum] = e.quantity;
      //qtyDict[e.locationNum] = qtyDict[e.locationNum] + e.quantity;
    });
    list1.forEach(e => {
      const le = { ...e }; // use a copy data

      if (qtyDict[e.locationNum]) le.quantity = qtyDict[le.locationNum];

      if (le.quantity > 0) list3.push(le);
      else list4.push(le);
    });
    //console.log('v1', qtyDict, list3);
    list3.sort((a, b) => b.quantity - a.quantity);
    list4.sort((a, b) => a.locationCode.localeCompare(b.locationCode));

    return [ ...list3, ...list4 ].sort((a, b) => b.quantity - a.quantity).map(e => ({
      ...e,
      value: e.locationNum,
      key: `${e.locationNum}-${e.lotNumber}-${e.uom}`,
      label: e.quantity > 0 ? `${e.locationCode}(${e.quantity})` : `${e.locationCode}`,
    }));
  };

  /*const handleSearch = (value: string) => {
    if (value) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      timerRef.current = setTimeout(() => fetchLocations(value), 300);
    } else {
      setData([]);
    }
  };*/

  // eslint-disable-next-line
  const isDiffProduct = () => {
    let ret = false;

    if (props.product && props.product.fulfillmentProductNum !== currentProductId) {
      ret = true;
    }

    // @ts-ignore
    if (!ret && !props.product && currentProductId > 0) ret = true;

    return ret;
  };

  const loadLocationList = async (needLoadingState = false) => {
    if (!props.warehouseId) return;

    if (needLoadingState) setIsLoading(true);

    try {
      const res = await fetchWarehouseLocationList(
        props.warehouseId,
        props.showPick ? true : false,
        undefined,
        props.locationType,
      );
      console.log('res ->', props.locationQuery, res);
      if (Array.isArray(res)) {
        setData(res);
        return res;
      }
    } catch(e) {
      message.error(`Loaded location list error: ${e}`);
    } finally {
      if (needLoadingState) setIsLoading(false);
    }
  };

  const loadPrdLocationList = async (needLoadingState = false) => {
    if (!props.warehouseId) return;
    if (!props.product) return;

    if (needLoadingState) setIsLoading(true);

    try {
      console.log('p', props);
      const ls = await fetchWarehouseProductLocationList(
        // @ts-ignore
        props.warehouseId,
        props.product.fulfillmentProductNum,
      );

      if (Array.isArray(ls)) return ls;
    } catch(e) {
      message.error({
        content: `Loaded location list of about the product(${props.product.sku}) error: ${e}`,
      });
    } finally {
      if (needLoadingState) setIsLoading(false);
    }
  };

  // eslint-disable-next-line
  const loadOptionList = async () => {
    //const { form, title, value } = props;
    //const { form, title } = props;
    if (!props.product) return;

    /*if (title && form) {
      let obj: any = {};

      obj[title] = null;
      form?.setFieldsValue(obj);
    }*/
    setFormValue(null);
    setIsLoading(true);
    props.isLoadingOptions && props.isLoadingOptions(true);

    const locations = await loadLocationList();
    const prdLocations = await loadPrdLocationList();

    if (Array.isArray(prdLocations)) setPrdLocationList(prdLocations);
    if (Array.isArray(locations)) setWhLocationList(locations);
    setIsLoading(false);
    props.isLoadingOptions && props.isLoadingOptions(false);
    console.log('l l', locations, prdLocations);

    /*
    if (Array.isArray(locations) && title && form && value) {
      const option = locations.find(item => item.locationNum === value);
      //if (locations.find(item => item.locationCode.toUpperCase().includes(value.toUpperCase()))) {
      if (option) {
        let obj: any = {};

        //obj[title] = res[0].locationNum
        obj[title] = option.locationNum;
        form.setFieldsValue(obj);
      }
    }
    */
  };

  const onSelect = (value: number, location: StringKAnyVPair) => {
    currentSelectionRef.current = value;
    props.onChange(value, location);
  };

  const optionStyle = (opt: StringKAnyVPair) => {
    return {
      color: props.optionVersion === 1 && opt.quantity > 0 ? 'green' : undefined,
    };
  };

  const renderOptionList = () => {
    const optList = getOptionList();
    let isDefaultValueNeeded = false;

    if (optList.length > 0) {
      if (props.defaultSelectOneOption && optList.length === 1) {
        onSelect(optList[0].locationNum, optList[0]);
        setFormValue(optList[0].locationNum);
      } else {
        //console.log('find', optList.find(e => e.locationNum > 0 && e.locationNum === props.value), props.optionVersion);
        if (!optList.find(e => e.locationNum > 0 && e.locationNum === props.value)) {
          setFormValue(null);
        }

        if (props.useLastValue) {
          if (currentSelectionRef.current) {
            const prevSel = optList.find(e => e.locationNum > 0 && e.locationNum === currentSelectionRef.current);

            if (prevSel) {
              setFormValue(prevSel.locationNum);
              onSelect(prevSel.locationNum, prevSel);
              //console.log('cv', currentSelectionRef.current, prevSel);
            }
          } else {
            isDefaultValueNeeded = !!props.defaultValue;
          }
        } else {
          isDefaultValueNeeded = !!props.defaultValue;
        }
      }

      if (isDefaultValueNeeded) {
        const defSel = optList.find(e => e.locationNum > 0 && e.locationNum === props.defaultValue);

        if (defSel) {
          setFormValue(defSel.locationNum);
          onSelect(defSel.locationNum, defSel);
        }
      }
    } else {
      setFormValue(null);
    }

    return optList.map((item) => (
      <Select.Option key={item.key} value={item.locationNum}>
        <span style={optionStyle(item)}>{item.label}</span>
      </Select.Option>
    ));
  };

  const setFormValue = (value: any) => {
    const { form, title } = props;

    if (title && form) {
      let obj: any = {};

      obj[title] = value;
      form?.setFieldsValue(obj);
    }
  };

  React.useEffect(() => {
      if (currentLocationType !== props.locationType
          || currentWhId !== props.warehouseId
          || isDiffProduct()) {
        if (props.warehouseId && props.product) {
          loadOptionList();
        } else {
          if (!props.warehouseId) {
            setWhLocationList([]);
            setPrdLocationList([]);
          }

          (!props.product) && setPrdLocationList([]);
        }
        setCurrentLocationType(props.locationType);
        setCurrentWhId(props.warehouseId);

        //if (props.product) setCurrentProductId(props.product.fulfillmentProductNum);
        setCurrentProductId(props.product ? props.product.fulfillmentProductNum : undefined);
      }
  }, [
    currentLocationType,
    currentWhId,
    isDiffProduct,
    loadOptionList,
    props,
  ]);

  return isLoading ? <LoadingIcon /> : (
    <Select
      allowClear={props.allowClear}
      defaultActiveFirstOption={false}
      defaultValue={props.defaultValue}
      disabled={!props.warehouseId || props.disabled}
      filterOption={filterOption}
      notFoundContent={(null)}
      placeholder="Input search text"
      showArrow={false}
      showSearch
      style={props.style ? { width: '100%', ...props.style } : { width: '100%' }}
      //value={props.value}
      value={currentSelectionValue()}
      // onSearch={handleSearch}
      // onSelect={(value:any) => console.log('%$$$$$$$',value)}
      onSelect={(value: number) => {
        const row = data.find((i) => i.locationNum === value);

        if (row) onSelect(value, row);
      }}
    >
      {renderOptionList()}
    </Select>
  );
};

export default SearchSelect;
